<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      dark
      src="@/assets/img/bgDrawer.jpg"
    >
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <!-- <v-btn plain @click="clkHome"> -->
            <v-img  src="@/assets/img/logo.png" alt="Logo" />
            <!-- </v-btn> -->
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="title">Siproquim</v-list-item-title>
            <v-list-item-subtitle>Consultoria</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list dense>
        <v-list-item v-for="([icon, text, method], i) in items" :key="i" link>
          <v-list-item-icon class="justify-center">
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="subtitile-1"
              >{{ text }}{{ method }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      :color="color"
      :flat="flat"
      dark
      class="px-15"
      :class="{ expand: flat }"
    >
      <v-toolbar-title>
        <v-img @click="clkHome" src="@/assets/img/logo.png" max-width="50px" />
      </v-toolbar-title>
      <v-spacer />
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="mr-4"
        v-if="isXs"
      />
      <div v-else>
        <v-btn text @click="cklSobre">
          <span class="mr-2">Sobre</span>
        </v-btn>
        <!-- <v-btn text @click="clkPrecos">
          <span class="mr-2">Preços</span>
        </v-btn> -->
        <v-btn rounded light @click="clkPrecos">
          <span class="mr-2">Inicie agora</span>
        </v-btn>
      </div>
    </v-app-bar>
  </div>
</template>

<style scoped>
.v-toolbar {
  transition: 0.6s;
}

.expand {
  height: 80px !important;
  padding-top: 10px;
}
</style>

<script>
import { mixpanel } from "@/main";
export default {
  data: () => ({
    drawer: null,
    isXs: false,
    items: [
      ["mdi-information-outline", "Sobre", globalThis.clkPrecos],
      // ["mdi-download-box-outline", "Download", "#download"],
      // ["mdi-currency-usd", "Preços", globalThis.clkPrecos],
      ["mdi-email-outline", "Inicie agora", globalThis.clkContate],
    ],
  }),
  props: {
    color: String,
    flat: Boolean,
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
    clkHome() {
      this.$vuetify.goTo("#hero");
      mixpanel.track("Para Home Click");
    },
    cklSobre() {
      this.$vuetify.goTo("#features");
      mixpanel.track("Para Sobre Click");
    },
    clkPrecos() {
      this.$vuetify.goTo("#pricing");
      mixpanel.track("Para Preços Click");
    },
    clkContate() {
      this.$vuetify.goTo("#pricing");
      mixpanel.track("Para Preços Click");
    },
  },

  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>
